import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange, handlePageSizeChange, handleLagOffsetChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { workspaceThrottleEnabled, workspaceStoreFullMessage, pageSize, lagOffset } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  const internalHandlePageSizeChange = (e) => {
    const { value } = e.target;
    onChange(e);
    if (value >= 1e3) {
      handlePageSizeChange("");
    } else {
      handlePageSizeChange("Page size must be at least 1000");
    }
  };
  const internalHandleLagOffsetChange = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      onChange(e);
      handleLagOffsetChange("");
    } else {
      handleLagOffsetChange("Lag time offset cannot be negative");
    }
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(
    ThrottlingCheckbox,
    {
      id: "wrokspaceThrottleEnabled",
      defaultChecked: workspaceThrottleEnabled == null ? void 0 : workspaceThrottleEnabled.value,
      onChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pageSize",
      type: "number",
      value: pageSize.value,
      min: "1000",
      onChange: internalHandlePageSizeChange,
      required: true,
      help: "Determines the maximum number logs to return per page of query results.",
      label: "Page size"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "lagOffset",
      type: "number",
      value: lagOffset.value,
      min: "0",
      onChange: internalHandleLagOffsetChange,
      required: true,
      help: "Indicate the delay between when the log event occurs and when data is available in the admin console.",
      label: "Lag time Offset (hours)"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "workspaceStoreFullMessage",
      type: "checkbox",
      value: "enable-storeFullMessage",
      defaultChecked: workspaceStoreFullMessage == null ? void 0 : workspaceStoreFullMessage.value,
      onChange,
      label: "Store Full Message",
      help: "Store the full original message in the full_message field?"
    }
  ));
};
export default FormAdvancedOptions;
